// How a project's testing status is spelled and coloured.
//
// `testing_status` is DERIVED server-side (projects has no status column) — see
// _testing_status in backend/api/routers/project.py. Keeping the labels here
// means the Projects table and the company Overview can never disagree about
// what "cases_ready" is called or which colour it wears.
//
// Note this is distinct from staffing: a project with no tester CANNOT be run,
// but that is a fact about the team, not about the testing, and it gets its own
// badge rather than overwriting the status.

export const PROJECT_STATUS = {
  crawling: { label: "Crawling", tone: "sky", live: true },
  generating: { label: "Generating", tone: "sky", live: true },
  running: { label: "Running tests", tone: "brand", live: true },
  active: { label: "Active", tone: "emerald" },
  cases_ready: { label: "Cases ready", tone: "sky" },
  idle: { label: "Idle", tone: "slate" },
  not_started: { label: "Not started", tone: "slate" },
  failed: { label: "Failed", tone: "rose" },
};

// Order the status chips read in: work in flight first, then healthy, then the
// ones that want attention. Used for the Overview strip and the table filter, so
// both list them the same way.
export const STATUS_ORDER = [
  "crawling", "generating", "running", "active", "cases_ready", "idle", "not_started", "failed",
];

export function statusMeta(key) {
  return PROJECT_STATUS[key] || { label: key || "Unknown", tone: "slate" };
}

// { active: 3, idle: 1, ... } over a project list, in STATUS_ORDER, skipping
// statuses nobody is in — an Overview strip listing six zeroes says nothing.
export function statusCounts(projects) {
  const counts = {};
  (projects || []).forEach((p) => {
    const key = p.testing_status || "not_started";
    counts[key] = (counts[key] || 0) + 1;
  });
  return STATUS_ORDER.filter((k) => counts[k]).map((k) => ({ key: k, count: counts[k], ...statusMeta(k) }));
}
